module.exports = __webpack_public_path__ + "static/media/anketad.8c3b30d1.doc";